'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconLock, iconLockTag } from '@ni/nimble-components/dist/esm/icons/lock';
import { wrap } from '../../utilities/react-wrapper';

export type { IconLock };
export { iconLockTag };
export const NimbleIconLock = wrap(IconLock);